import { useAxios } from "@/hooks/useAxios";
import { IValuatingInput, ValuatedType } from "@/store/propertyState";
import { API_VALUATION } from "@/types/endpoint";

type IUpload = IValuatingInput;

interface IDownload {
  status: string | null;
  message: string | null;
  // value: number;
  result: ValuatedType;
}

type IStored = ValuatedType;

function processing(downloaded: IDownload) {
  return downloaded.result;
}

export const useValuation = () => {
  return useAxios<IUpload, IDownload, IStored>(API_VALUATION, processing);
};
